<template>
<nav>
  <a v-show="!collapse" :href="ibcHome" >
    <img :src="logo" />
  </a>
  <global-filters v-show="!collapse" v-if="globalFilters" />
  <div v-if="allowSecondaryBoards" class="secondary-switch" >
    <el-switch
      v-model="secondary"
      :active-text="secondaryBoardText"
      :inactive-text="primaryBoardText" />
  </div>
  <el-menu
    :default-active="active"
    :default-openeds="['/boards']"
    :collapse="collapse"
    :router="true"
    text-color="#ccc"
    active-text-color="#fff"
    background-color="#2f4050"
    >
    <el-submenu index="/boards" >
      <template slot="title">
        <i class="el-icon-fa-home" ></i>
        <span slot="title">Indicateurs</span>
      </template>
      <el-menu-item
        v-for="board in accessibleBoards.filter(b => !allowSecondaryBoards || b.secondary === secondary)"
        :key="board.id"
        :index="'/boards/' + board.id"
        :title="board.name" >
        {{ board.name }}
      </el-menu-item>
    </el-submenu>
    <el-menu-item index="/confidentiality" >
      <i class="el-icon-fa-info-circle"></i>
      <span slot="title">Confidentialité</span>
    </el-menu-item>
    <el-menu-item v-for="(item, i) in items" :key="i" :index="item.path" >
        <i :class="item.icon"></i>
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </el-menu>
  </nav>
</template>

<script>
import {MyContract} from '@/contracts/components'
import {api} from 'macarons'
import GlobalFilters from './GlobalFiltersv2.vue'

export default {
  components: {
    MyContract,
    GlobalFilters
  },
  props: {
    collapse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      logo: '',
      accessibleBoards: [],
      secondary: false
    }
  },
  created () {
    if (!window[window.macarons].globalFilters) {
      this.accessibleBoards.splice(0, this.accessibleBoards.length, ...this.boards)
    }
  },
  watch: {
    contract () {
      this.fetchLogo()
    },
    logged () {
      this.updateAccessibleBoards()
    },
    globalFilterList () {
      this.updateAccessibleBoards()
    },
    boards () {
      if (!window[window.macarons].globalFilters) {
        this.accessibleBoards.splice(0, this.accessibleBoards.length, ...this.boards)
      } else {
        this.updateAccessibleBoards()
      }
    },
    secondary () {
      if (this.allowSecondaryBoards) {
        this.$store.commit('setSecondary', this.secondary)
        if (window.location.hash.match(/^#\/boards\/\d+$/)) {
          if (this.$store.state.board.data.secondary !== this.secondary) {
            this.$router.push(
              `/boards/${this.accessibleBoards.filter(b => b.secondary === this.secondary)[0].id}`
            )
          }
        }
      }
    }
  },
  computed: {
    allowSecondaryBoards () {
      return !!window[window.macarons].allowSecondaryBoards
    },
    primaryBoardText () {
      return window[window.macarons].primaryBoardText || 'Mode comparaison'
    },
    secondaryBoardText () {
      return window[window.macarons].secondaryBoardText || 'Mode cumul'
    },
    ibcHome () {
      return window[window.macarons].ibcHome
    },
    contract () {
      return this.$store.state.chloe.contract
    },
    active () {
      return this.$route.path
    },
    logged () {
      return this.$store.state.token !== null
    },
    boards () {
      return this.$store.getters.getBoards
    },
    items () {
      return this.$store.state.menu.items
    },
    globalFilterList () {
      return this.$store.state.chloe.globalFilters
    },
    globalFilters () {
      // @todo better criteria
      return window[window.macarons].globalFilters
    }
  },
  methods: {
    updateAccessibleBoards () {
      Promise.all(this.boards.map(board => new Promise(resolve => {
        this.$store.dispatch('getBoardAccess', board.id).then(access => {
          resolve({ board, access })
        })
      }))).then(boardAccesses => {
        this.accessibleBoards.splice(
          0,
          this.accessibleBoards.length,
          ...boardAccesses.filter(board => board.access).map(board => board.board)
        )
      })
    },
    async fetchLogo () {
      try {
        let {data} = await api.get('contract/logo', {responseType: 'blob'})
        this.logo = URL.createObjectURL(data)
      } catch (err) {
        this.logo = ''
      }
    }
  },
  mounted () {
    this.$store.dispatch('load')
    this.fetchLogo()
  }
}
</script>
<style lang="scss" scoped>
@import "./../../style/colors.scss";

nav {
  background-color: $--background-color-menu;
  border-right: 1px #e6e6e6 solid;
  a img {
    max-width: 240px;
    max-height: 150px;
  }
}

.el-menu {
  height: 100vh;
  max-width: 240px;
  will-change: width;
  border-right: none;
}

.el-menu:not(.el-menu--collapse) {
  width: 240px;
  overflow: hidden;
}

.el-menu-item {
  text-align: left;
  font-weight: 500;
  font-size: 0.9em;
  line-height: 46px;
  height: 46px;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.is-active:not(.is-opened) {
  border-left: 4px $--color-primary solid;
}
.is-active:not(.is-opened):not(.el-submenu) {
  padding-left: 16px!important;
}
.el-submenu {
  text-align: left;
  .el-menu .is-active:not(.is-opened) {
      padding-left: 36px!important;
  }
}
.secondary-switch {
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/macarons/components/Menu.vue